import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";

/** Name search for the config list; sits first in the filter chip row. */
export const ConfigSearchInput = ({
  referAsClients,
  value,
  onChange,
}: {
  referAsClients: boolean;
  value: string;
  onChange: (value: string) => void;
}) => {
  const { t } = useTranslation(["coaching-portal", "common"]);
  return (
    <div className="athletes-config-list__search">
      <SvgIcon src="/img/new-icons/search.svg" alt="" />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t("coaching-portal:athletes.header.searchPlaceholder", {
          role: referAsClients
            ? t("coaching-portal:athletes.roleClientLower")
            : t("coaching-portal:athletes.roleAthleteLower"),
        })}
        className="athletes-config-list__search-input"
      />
      {value && (
        <button
          type="button"
          className="athletes-config-list__search-clear"
          onClick={() => onChange("")}
          aria-label={t("common:clear")}
        >
          <SvgIcon src="/img/new-icons/cross-light.svg" alt="" />
        </button>
      )}
    </div>
  );
};
